import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { ImageEditorComponent } from "@syncfusion/ej2-react-image-editor";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";

function ImageEditorModal({
  width = "900px",
  allowModalPadding = false,
  heading,
  closeModal,
  onSubmitFunction,
  existingImg,
}) {
  const { t } = useTranslation();
  const imageEditorRef = useRef(null);
  const [isFileImported, setIsFileImported] = useState(false);

  function onCreateEditor() {
    if (existingImg) {
      imageEditorRef.current.open(existingImg);
    }
  }

  useEffect(() => {
    if (imageEditorRef.current) {
      onCreateEditor();
    }
  }, [existingImg]);

  const saveImageData = async () => {
    const canvasCreated = imageEditorRef.current.exportModule.exportToCanvas();
    const base64EncodedImg = canvasCreated.toDataURL("image/jpeg");

    await onSubmitFunction(base64EncodedImg);
    closeModal();
  };

  const fileOpened = () => {
    setIsFileImported(true);
  };

  const headerContent = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <span>{heading || t("Edit Picture")}</span>
    </div>
  );

  const toolbar = [
    "Open",
    "Undo",
    "Redo",
    "ZoomIn",
    "ZoomOut",
    "Crop",
    "Annotate",
    "Finetune",
    "Filter",
    "Frame",
    "Resize",
    "Reset",
  ];

  const modelContent = () => (
    <div>
      <div className="profileCropperContent" style={{ height: "400px" }}>
        <ImageEditorComponent
          created={onCreateEditor}
          id="image-editor-modal"
          toolbar={toolbar}
          ref={imageEditorRef}
          fileOpened={fileOpened}
        />
      </div>
    </div>
  );

  const footerContent = () => (
    <div className="flex gap-4">
      <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={closeModal}>
        {t("Cancel")}
      </ButtonComponent>
      <ButtonComponent disabled={!isFileImported} buttonType={BUTTON_TYPES.GRADIENT_BUTTON} onClick={saveImageData}>
        {t("Save Changes")}
      </ButtonComponent>
    </div>
  );

  return (
    <ModalStateDialogComponent
      width={width}
      allowModalPadding={allowModalPadding}
      headerTitle={headerContent()}
      footerContent={footerContent()}
      onCancel={closeModal}
      modelContent={modelContent()}
      isVisible
    />
  );
}

export default ImageEditorModal;
